import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { combineClasses } from "../../../utilities/combineClasses.js";
import { TooltipIndicator } from "../../tooltipIndicator/TooltipIndicator.js";
import { useFieldContext } from "./FieldContext.js";
import Label_module from "./Label.module.js";
const Label = /*#__PURE__*/ forwardRef(({ className, required, disabled, testId = 'label', tooltip, tooltipIndicatorProps, children, ...props }, ref)=>{
    const fieldContext = useFieldContext();
    const isRequired = required ?? fieldContext?.required;
    return /*#__PURE__*/ jsxs("div", {
        className: Label_module.labelWrapper,
        children: [
            /*#__PURE__*/ jsxs("label", {
                ref: ref,
                id: fieldContext?.labelId,
                htmlFor: fieldContext?.inputId,
                onClick: fieldContext?.inputType === 'select' ? ()=>{
                    document.querySelector(`#${fieldContext.inputId}`)?.focus();
                } : void 0,
                className: combineClasses(className, Label_module.label, disabled && Label_module.disabled),
                "data-testid": testId || void 0,
                ...props,
                children: [
                    children,
                    isRequired && /*#__PURE__*/ jsx("span", {
                        "aria-hidden": true,
                        className: Label_module.required,
                        children: "*"
                    })
                ]
            }),
            tooltip && /*#__PURE__*/ jsx(TooltipIndicator, {
                text: tooltip,
                ...tooltipIndicatorProps,
                iconProps: {
                    ...tooltipIndicatorProps?.iconProps,
                    className: combineClasses(Label_module.tooltipAnchor, tooltipIndicatorProps?.iconProps?.className)
                }
            })
        ]
    });
});
Label.displayName = 'Label';
export { Label };
